<div class="image-preview-modal" (click)="close()">
  <button class="close-button" (click)="close()">
    <ion-icon name="close" class="close-icon"></ion-icon>
  </button>
  <img [src]="imageUrl" alt="Powiększone zdjęcie" class="full-image" />
</div>
